import { API_CONFIG } from 'constants/config';

// eslint-disable-next-line import/prefer-default-export
export const getSequenceErrorsCSVLink = sequenceId => (
  `${API_CONFIG.API_BASE}${API_CONFIG.API_VERSIONS.V1}sequences/${sequenceId}/csv-errors/`
);
